/**
 * Created by Ning Jiang on 5/24/2018.
 */
import {FruitsGameConfig} from "../FruitsGameConfig";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import { TimelineLite, TimelineMax } from "gsap";


export class FruitsHelper {

    public static translateReelId(oldReelId:number, oldSymId:number):number {
        let newId:number = oldReelId * 3 + oldSymId;
        if(newId === 0 || newId === 3) {
            debugger;
            throw new Error("FruitsHelper.translateSymbolPositions() there is no symbol on 0, 0 or 1, 0!");
        }

        if(newId < 3) {
            return newId - 1;
        }

        return newId - 2;
    }

    public static translateReelIndex(index:number):[number, number] {
        if(index < 4) {
            return [Math.floor(index / 2), index % 2 + 1];
        } else {
            return [Math.floor((index - 4) / 3) + 2, (index - 4) % 3];
        }
    }

    public static getSymbolPosition(reelID:number, symbolID:number, orientation:string, positionMode:string = "NORMAL"):number[] {

        let size:[number, number] = [0, 0];
        let pos:[number, number] = [0, 0];

        let reelAreaPosX:number = FruitsGameConfig.instance.REEL_AREA_POS_X;
        let reelAreaPosY:number = FruitsGameConfig.instance.REEL_AREA_POS_Y;

        let symbolWidth:number = FruitsGameConfig.instance.SYMBOL_WIDTH;
        let symbolHeight:number = FruitsGameConfig.instance.SYMBOL_HEIGHT;

        let symbolGap:[number, number] = FruitsGameConfig.instance.REELS_SPACING;
        let isX4:boolean = false;

        if(reelID > 1) {
            pos = (<any>FruitsGameConfig.instance)[`_X4_POSITION_${positionMode}_${orientation.toUpperCase()}`];
            size = FruitsGameConfig.instance.REELS_X4_SIZE;
            reelID -= 2;
        } else {
            pos = (<any>FruitsGameConfig.instance)[`_X2_POSITION_${positionMode}_${orientation.toUpperCase()}`];
            size = FruitsGameConfig.instance.REELS_X2_SIZE;
            symbolID -= 1;
            isX4 = true;
        }

        if(orientation === Orientation.LANDSCAPE)
            return [pos[0] - size[0] / 2 + symbolWidth / 2 + symbolGap[0] + reelAreaPosX + (reelID * (symbolWidth + symbolGap[0])),
                pos[1] - size[1] / 2 + symbolHeight / 2 + symbolGap[1] + reelAreaPosY + (symbolID * (symbolHeight + symbolGap[1]))];
        else
            return [pos[0] + size[0] / 2 - (isX4 ? symbolWidth / 2 : symbolWidth) - symbolGap[0] + reelAreaPosX - symbolID * (symbolWidth + symbolGap[0]),
                pos[1] - size[1] / 2 + (isX4 ? symbolHeight / 2 : 0) + symbolGap[1] + reelAreaPosY + (reelID * (symbolHeight + symbolGap[1]))];
    }

    public static checkItemExists(array:any[], itemToSearch:any):boolean {
        let returnVal:boolean = false;
        array.forEach(
            (item) => {
                if(item === itemToSearch)
                    returnVal = true;
            }
        );
        return returnVal;
    }

    public static determineScatterLevel(scatterIndex:number):number {
        if(scatterIndex < 4)
            return 1;
        else if(scatterIndex >= 4 && scatterIndex < 7)
            return 2;
        else if(scatterIndex >= 7 && scatterIndex < 9)
            return 3;
        else
            return 4;
    }

    public static determineIndicatorLevel(indicatorVal:number):number {
        if(indicatorVal > -1 && indicatorVal < 3) {
            return 1;
        } else if(indicatorVal > 2 && indicatorVal < 6) {
            return 2;
        } else if(indicatorVal > 5 && indicatorVal < 8) {
            return 3;
        } else {
            return 4;
        }
    }

    public static timeLineNuller(_timeline:TimelineLite | TimelineMax):null{
        _timeline.pause();
        _timeline.clear();
        _timeline.kill();

        return null;
    }

    public static randomizeSymbol():string {
        let reelSet:string[] = ["L1", "L2", "L3", "L4", "M1", "M2", "M3", "M4", "M5", "M6", "W", "S"];

        let ind:number = Math.floor(Math.random() * 11);
        return reelSet[ind];
    }
}